<template>
  <div class="page">
    <div class="page-body">
      <transition name="page-transition">
        <keep-alive :include="['serveIndex', 'hospitalIndex', 'userIndex']">
          <router-view />
        </keep-alive>
      </transition>
    </div>
    <groupNavBar v-if="user.IsGroupSystem"></groupNavBar>
    <nav-bar v-else></nav-bar>
    <van-icon
      v-if="hasToHome"
      class="to-home"
      name="wap-home-o"
      @click="jumpToHome"
    />
    <audio muted ref="MyAudio" preload="auto" v-if="!user.IsGroupSystem">
      <source src="@/assets/images/tipaudio.mp3" type="audio/mp3" />
      您的浏览器不支持 audio 标签。
    </audio>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { Toast, Icon, Dialog } from "vant";
import NavBar from "./NavBar";
import groupNavBar from "./groupNavBar";
import messageApi from "@/api/message";
import { ls } from "@/utils//cache";
import { USERINFO } from "@/store/mutation-types";
// import { GetDefaultItem } from "@/api/common.js";
Vue.use(Toast);
export default {
  name: "BasicLayout",
  components: {
    NavBar,
    groupNavBar,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },

  data() {
    return {
      toastIndex: 0,
      timer: null,
      // hasToHome:true
    };
  },
  computed: {
    ...mapState({
      user: state => (state.user.info ? state.user.info : {}),
    }),
    hasToHome() {
      if (this.$route.meta.isRestaurant) {
        return false;
      }
      return true;
    },
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    if (this.$route.meta.isRestaurant) {
      return;
    }
    this.checkChannelOrder();
    const changeStore = ls.get("web_changeStore");
    if (changeStore && changeStore.status) {
      ls.remove("web_changeStore");
      Dialog.alert({
        message: changeStore.msg,
      }).then(() => {
        // on close
      });
      // this.$notification.info({
      //   message: "提示",
      //   description: h("div", [arr]),
      //   placement: "bottomRight",
      //   style: {
      //     width: "450px",
      //     marginBottom: "0",
      //     marginLeft: `${335 - 400}px`
      //   },
      //   key1
      // });
    }
    // GetDefaultItem({}).then(res => {
    // });
  },
  mounted() {
    if (this.$route.meta.isRestaurant) {
      return;
    }
    var self = this;
    let connection = new signalR.HubConnectionBuilder()
      .withUrl(this.$config.http.serverUrl + "/pmsHub", {
        accessTokenFactory: () => self.user.Token,
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();
    connection.on("showMessageCount", res => {
      this.setMessageCount(res.count);
    });

    connection.on("showNightCheck", res => {
      if (res.status) {
        this.toastIndex = Toast.loading({
          message: res.message,
          forbidClick: true,
          loadingType: "spinner",
          overlay: true,
          duration: 0,
        });
      } else {
        this.toastIndex.clear();
        this.logout();
      }
    });
    connection.on("channelOrderConfirm", res => {
      if (!this.user.IsGroupSystem) {
        this.showMsg(res);
      }
    });
    connection.on("changeCompany", res => {
      const _this = this;
      const userInfo = ls.get(USERINFO);
      const isChange = ls.get("web_isChangeStatus");
      if (
        userInfo &&
        res.companyId != userInfo.CompanyId &&
        res.userId == userInfo.OperatorId &&
        !isChange
      ) {
        ls.set("web_changeStore", { status: true, msg: res.message });
        const data = res.loginMessage;
        const json = {
          ..._this.user,
          CompanyId: res.companyId,
          GroupId: res.groupId,
          CompanyName: data.companyName,
          AccountDate: data.accountDate,
          IsGroupSystem: data.isGroupSystem,
          Menus: data.menus.map(v => {
            v.id = String(v.id);
            if (v.childs && v.childs.length) {
              v.childs = v.childs.map(el => {
                el.id = String(el.id);
                const child = {};
                for (let ckey in el) {
                  const newCKey =
                    ckey.slice(0, 1).toUpperCase() + ckey.slice(1);
                  child[newCKey] = el[ckey];
                }
                return child;
              });
            }
            const item = {};
            for (let key in v) {
              const newKey = key.slice(0, 1).toUpperCase() + key.slice(1);
              item[newKey] = v[key];
            }
            return item;
          }),
          IsVirtual: data.isVirtual,
          Permissions: data.permissions,
        };
        ls.set(USERINFO, json);
        location.reload();
      }
      setTimeout(() => {
        ls.set("web_isChangeStatus", false);
      }, 2000);
    });

    //指派清洁员
    connection.on("cleanFlowRemind", res => {
      const _this = this;
      Dialog.confirm({
        message: "您有新的房务管理消息，是否立即查看？",
      }).then(() => {
        const roomLogStatus = res.roomLogStatus;
        if (_this.$route.name == "RoomServiceIndex") {
          var url =
            window.location.origin +
            window.location.pathname +
            "?roomLogStatus=" +
            roomLogStatus;
          window.history.pushState({}, 0, url);
          setTimeout(() => {
            location.reload();
          }, 100);
          // location.reload();
        } else {
          _this.$router.push({
            name: "RoomServiceIndex",
            query: {
              roomLogStatus: roomLogStatus,
            },
          });
        }
      });
    });
    connection
      .start()
      .then(() => {})
      .catch(error => {
        return console.log(error);
      });
  },
  methods: {
    ...mapActions(["setMessageCount", "logout"]),
    showMsg(res) {
      const _this = this;

      this.$nextTick(() => {
        if (_this.$refs.MyAudio) {
          _this.$refs.MyAudio.pause();
          _this.$refs.MyAudio.muted = false;
          _this.$refs.MyAudio.play();
        }
      });
      Dialog.alert({
        message: res.message,
        confirmButtonText: "去查看",
        closeOnClickOverlay: true,
      }).then(() => {
        if (_this.$route.name == "message") {
          // location.reload();
        } else {
          _this.$router.push({
            name: "message",
            query: {
              active: 5,
            },
          });
        }
      });
    },
    checkChannelOrder() {
      this.getMsgData();
      this.timer = setInterval(() => {
        this.getMsgData();
      }, 2 * 60 * 1000);
    },
    getMsgData() {
      if (!this.user.IsGroupSystem) {
        messageApi
          .GetChanelMessagePage({
            PageIndex: 0,
            PageSize: 100,
            IsQueryAll: false,
            IsConfirm: false,
          })
          .then(res => {
            if (res.Data.Total) {
              this.showMsg({
                message:
                  "您目前共有" +
                  res.Data.Total +
                  "个渠道订单未确认接收，请及时处理",
              });
            }
          });
      }
    },
    jumpToHome() {
      if (this.user.IsGroupSystem) {
        this.$router.push({ name: "groupIndex" });
      } else {
        this.$router.push({ name: "index" });
      }
    },
  },
};
</script>

<style lang="less">
.page-body {
  overflow: hidden;
  overflow-y: auto;
}
.page-transition-enter {
  transform: translateX(40%);
  opacity: 0;
}

.page-transition-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.page-transition-enter-active {
  transition: ease 0.2s;
  display: inline-block;
}
.to-home {
  position: fixed;
  bottom: 70px;
  right: 20px;
  // border: 1px solid #c3e1ff;
  padding: 8px;
  border-radius: 100%;
  background: #fff;
  color: #96caff;
  z-index: 999;
  background: #90caf5;
  color: #fff;
  &:focus,
  &:active {
    background: #fafafa;
  }
}
</style>
